export enum ShipperType {
  POSTI = "POSTI",
  UPS = "UPS",
  DHL = "DHL",
  MANUAL = "MANUAL",
  CONTACT_CS = "CONTACT_CS",
}
